export default {
  'title': "Le créneau pour la date que vous avez sélectionnée n'est plus disponible.",
  'schedule-slot': 'Programmer un autre créneau',
};
